import apiService from './ApiService';

const appendArrayParam = (params, key, values) => {
  if (!Array.isArray(values)) return;
  values
    .map((value) => String(value || '').trim())
    .filter(Boolean)
    .forEach((value) => params.append(key, value));
};

class AulaService {
  async getAulas(options = {}) {
    const params = new URLSearchParams();
    if (options.idColegio) params.append('idColegio', options.idColegio);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    if (options.search) params.append('search', options.search);
    appendArrayParam(params, 'materiaIds', options.materiaIds);
    appendArrayParam(params, 'profesorIds', options.profesorIds);
    const qs = params.toString();
    const response = await apiService.get(`/aulas${qs ? `?${qs}` : ''}`);
    const aulas = response?.aulas || response?.Aulas || response?.data || response || [];
    const items = Array.isArray(aulas) ? aulas : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return {
        items,
        total,
        resumen: response?.resumen || response?.Resumen || null,
        materias: response?.materias || response?.Materias || [],
        profesores: response?.profesores || response?.Profesores || [],
        topProfesores: response?.topProfesores || response?.TopProfesores || []
      };
    }
    return items;
  }

  async getAulasActivas(options = {}) {
    const params = new URLSearchParams();
    if (options.idColegio) params.append('idColegio', options.idColegio);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    if (options.search) params.append('search', options.search);
    appendArrayParam(params, 'materiaIds', options.materiaIds);
    appendArrayParam(params, 'profesorIds', options.profesorIds);
    const qs = params.toString();
    const response = await apiService.get(`/aulas/activos${qs ? `?${qs}` : ''}`);
    const aulas = response?.aulas || response?.Aulas || response?.data || response || [];
    const items = Array.isArray(aulas) ? aulas : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return {
        items,
        total,
        resumen: response?.resumen || response?.Resumen || null,
        materias: response?.materias || response?.Materias || [],
        profesores: response?.profesores || response?.Profesores || [],
        topProfesores: response?.topProfesores || response?.TopProfesores || []
      };
    }
    return items;
  }

  async getAulaById(id) {
    const response = await apiService.get(`/aulas/${id}`);
    const list = response?.aulas || response?.Aulas || [];
    return Array.isArray(list) && list.length > 0 ? list[0] : response?.aula || response?.Aula || response;
  }

  async getMisAulas(options = {}) {
    const params = new URLSearchParams();
    if (options.idColegio) params.append('idColegio', options.idColegio);
    if (options.start !== undefined && options.start !== null) params.append('start', options.start);
    if (options.end !== undefined && options.end !== null) params.append('end', options.end);
    if (options.search) params.append('search', options.search);
    const qs = params.toString();
    const response = await apiService.get(`/aulas/mis${qs ? `?${qs}` : ''}`);
    const aulas = response?.aulas || response?.Aulas || response?.data || response || [];
    const items = Array.isArray(aulas) ? aulas : [];
    const total = response?.total ?? response?.Total ?? items.length;
    if (options.includeTotal || options.start !== undefined || options.end !== undefined) {
      return { items, total };
    }
    return items;
  }

  async getMiAulaById(id) {
    const response = await apiService.get(`/aulas/mis/${id}`);
    const list = response?.aulas || response?.Aulas || [];
    return Array.isArray(list) && list.length > 0 ? list[0] : response?.aula || response?.Aula || response;
  }

  async getMisMateriasSeleccionablesParaAula(options = {}) {
    if (!options.idColegio) {
      throw new Error('No se encontró el colegio activo.');
    }

    const cursoIds = Array.isArray(options.cursoIds)
      ? options.cursoIds.map((id) => String(id || '').trim()).filter(Boolean)
      : [];

    const params = new URLSearchParams();
    params.append('idColegio', options.idColegio);
    if (options.cicloLectivo !== undefined && options.cicloLectivo !== null && options.cicloLectivo !== '') {
      params.append('cicloLectivo', options.cicloLectivo);
    }
    cursoIds.forEach((cursoId) => params.append('cursoIds', cursoId));

    const response = await apiService.get(`/aulas/mis/materias-seleccionables?${params.toString()}`);
    const materias = response?.materias || response?.Materias || response?.data || response || [];
    return Array.isArray(materias) ? materias : [];
  }

  async getMateriasSeleccionablesParaAula(options = {}) {
    if (!options.idColegio) {
      throw new Error('No se encontró el colegio activo.');
    }

    const cursoIds = Array.isArray(options.cursoIds)
      ? options.cursoIds.map((id) => String(id || '').trim()).filter(Boolean)
      : [];

    const params = new URLSearchParams();
    params.append('idColegio', options.idColegio);
    if (options.cicloLectivo !== undefined && options.cicloLectivo !== null && options.cicloLectivo !== '') {
      params.append('cicloLectivo', options.cicloLectivo);
    }
    cursoIds.forEach((cursoId) => params.append('cursoIds', cursoId));

    const response = await apiService.get(`/aulas/materias-seleccionables?${params.toString()}`);
    const materias = response?.materias || response?.Materias || response?.data || response || [];
    return Array.isArray(materias) ? materias : [];
  }

  async getMisAsistentesGptClasicosParaAula(options = {}) {
    if (!options.idColegio) {
      throw new Error('No se encontró el colegio activo.');
    }

    const params = new URLSearchParams();
    params.append('idColegio', options.idColegio);

    const response = await apiService.get(`/aulas/mis/asistentes-gpt-clasicos?${params.toString()}`);
    const asistentes = response?.asistentes || response?.Asistentes || response?.data || response || [];
    return Array.isArray(asistentes) ? asistentes : [];
  }

  async getAsistentesGptClasicosParaAula(options = {}) {
    if (!options.idColegio) {
      throw new Error('No se encontró el colegio activo.');
    }

    const params = new URLSearchParams();
    params.append('idColegio', options.idColegio);

    const response = await apiService.get(`/aulas/asistentes-gpt-clasicos?${params.toString()}`);
    const asistentes = response?.asistentes || response?.Asistentes || response?.data || response || [];
    return Array.isArray(asistentes) ? asistentes : [];
  }

  async getAulaAsistentesIA(aulaId) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }

    return apiService.get(`/aulas/${encodeURIComponent(aulaId)}/asistentes-ia`);
  }

  async addAulaAsistenteIA(aulaId, assistantId) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }
    if (!assistantId) {
      throw new Error('No se encontró el asistente.');
    }

    return apiService.post(`/aulas/${encodeURIComponent(aulaId)}/asistentes-ia`, {
      idOpenAIAssistant: assistantId
    });
  }

  async removeAulaAsistenteIA(aulaId, assistantId) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }
    if (!assistantId) {
      throw new Error('No se encontró el asistente.');
    }

    return apiService.delete(`/aulas/${encodeURIComponent(aulaId)}/asistentes-ia/${encodeURIComponent(assistantId)}`);
  }

  async updateAulaRecursosVisibilidad(aulaId, payload = {}) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }

    return apiService.put(`/aulas/${encodeURIComponent(aulaId)}/recursos-visibilidad`, payload);
  }

  async getAulaStats(id, options = {}) {
    if (!id) {
      throw new Error('No se encontró el aula.');
    }

    const params = new URLSearchParams();
    if (options.from) params.append('from', options.from);
    if (options.to) params.append('to', options.to);

    return apiService.get(`/aulas/${encodeURIComponent(id)}/estadisticas${params.toString() ? `?${params.toString()}` : ''}`);
  }

  async getAulaPublicaEstado(aulaId) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }
    return apiService.getPublic(`/aulas/publico/estado?id=${encodeURIComponent(aulaId)}`);
  }

  async getAulaPublicaDetalle(aulaId) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }
    return apiService.getPublic(`/aulas/publico/${encodeURIComponent(aulaId)}`);
  }

  async getAulaAccessDetalle(aulaId, token) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }
    if (!token) {
      throw new Error('La sesión del aula no es válida.');
    }
    return apiService.request(`/aulas/${encodeURIComponent(aulaId)}/detalle-acceso`, {
      method: 'GET',
      authTokenOverride: token
    });
  }

  async getAulaPublicaMensajes({ aulaId, captchaToken, start, end, search, remoteIp }) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }
    const payload = {
      aulaId,
      captchaToken,
      remoteIp: remoteIp || '',
      start,
      end,
      search
    };
    return apiService.postPublic('/aulas/publico/mensajes', payload);
  }

  async responderAulaMensajePublico(payload) {
    // payload: { aulaId, idMensajePadre, titulo?, contenidoHtml, nombreRemitente, autorEmail?, captchaToken }
    return apiService.postPublic('/aulas/publico/mensajes/responder', {
      aulaId: payload.aulaId,
      idMensajePadre: payload.idMensajePadre,
      titulo: payload.titulo,
      contenidoHtml: payload.contenidoHtml,
      nombreRemitente: payload.nombreRemitente,
      autorEmail: payload.autorEmail,
      captchaToken: payload.captchaToken
    });
  }

  async getAulaMensajesPrivados({ aulaId, token, start, end, search, scope }) {
    if (!aulaId || !token) {
      throw new Error('No se encontró la sesión del aula.');
    }
    const params = new URLSearchParams();
    if (start !== undefined && start !== null) params.append('start', start);
    if (end !== undefined && end !== null) params.append('end', end);
    if (search) params.append('search', search);
    if (scope) params.append('scope', scope);
    return apiService.request(`/aulas/${encodeURIComponent(aulaId)}/mensajes${params.toString() ? `?${params.toString()}` : ''}`, {
      method: 'GET',
      authTokenOverride: token
    });
  }

  async responderAulaMensajePrivado({ aulaId, token, idMensajePadre, titulo, contenidoHtml }) {
    if (!aulaId || !token) {
      throw new Error('No se encontró la sesión del aula.');
    }
    return apiService.request(`/aulas/${encodeURIComponent(aulaId)}/mensajes`, {
      method: 'POST',
      body: {
        idMensajePadre,
        titulo,
        contenidoHtml
      },
      authTokenOverride: token
    });
  }

  async getAulaPublicaArchivos(aulaId) {
    if (!aulaId) throw new Error('No se encontró el aula.');
    return apiService.getPublic(`/aulas/publico/archivos?aulaId=${encodeURIComponent(aulaId)}`);
  }

  async getAulaPrivadaArchivos(aulaId, token) {
    if (!aulaId || !token) throw new Error('No se encontró la sesión del aula.');
    return apiService.request(`/aulas/${encodeURIComponent(aulaId)}/archivos`, {
      method: 'GET',
      authTokenOverride: token
    });
  }

  async getAulaPublicaLinks(aulaId) {
    if (!aulaId) throw new Error('No se encontró el aula.');
    return apiService.getPublic(`/aulas/publico/links?aulaId=${encodeURIComponent(aulaId)}`);
  }

  async getAulaPrivadaLinks(aulaId, token) {
    if (!aulaId || !token) throw new Error('No se encontró la sesión del aula.');
    return apiService.request(`/aulas/${encodeURIComponent(aulaId)}/links`, {
      method: 'GET',
      authTokenOverride: token
    });
  }

  async downloadAulaPublicaArchivo(aulaId, archivoId) {
    const url = `${apiService.baseURLPublic || process.env.REACT_APP_API_BASE_URL || ''}/aulas/publico/${encodeURIComponent(
      aulaId
    )}/archivos/${archivoId}`;
    const resp = await fetch(url);
    if (!resp.ok) throw new Error('No pudimos descargar el archivo.');
    const blob = await resp.blob();
    return blob;
  }

  async downloadAulaPrivadaArchivo(aulaId, archivoId, token) {
    const url = `${process.env.REACT_APP_API_BASE_URL || apiService.baseURL}/aulas/${encodeURIComponent(aulaId)}/archivos/${archivoId}`;
    const resp = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (!resp.ok) throw new Error('No pudimos descargar el archivo.');
    return resp.blob();
  }

  async downloadAulaPublicaZip(aulaId) {
    const url = `${apiService.baseURLPublic || process.env.REACT_APP_API_BASE_URL || ''}/aulas/publico/${encodeURIComponent(
      aulaId
    )}/archivos/zip`;
    const resp = await fetch(url);
    if (!resp.ok) throw new Error('No pudimos descargar el zip.');
    const blob = await resp.blob();
    return blob;
  }

  async downloadAulaPrivadaZip(aulaId, token) {
    const url = `${process.env.REACT_APP_API_BASE_URL || apiService.baseURL}/aulas/${encodeURIComponent(aulaId)}/archivos/zip`;
    const resp = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (!resp.ok) throw new Error('No pudimos descargar el zip.');
    return resp.blob();
  }

  async validarAulaCodigo(aulaId, codigo) {
    if (!aulaId) {
      throw new Error('No se encontró el aula.');
    }
    return apiService.postPublic('/aulas/publico/validar-codigo', {
      aulaId,
      codigo
    });
  }

  async getAulaPublicaPorNickname(colegioNombreUrl, aulaNickname) {
    if (!colegioNombreUrl || !aulaNickname) {
      throw new Error('Faltan parámetros para buscar el aula.');
    }
    const qs = new URLSearchParams({
      colegio: colegioNombreUrl,
      aula: aulaNickname
    });
    return apiService.getPublic(`/aulas/publico/por-nickname?${qs.toString()}`);
  }

  async loginAulaPrivada({ aulaId, email, password, captchaToken }) {
    if (!aulaId) throw new Error('No se encontró el aula.');
    return apiService.postPublic('/aulas/publico/login', {
      aulaId,
      email,
      password,
      captchaToken
    });
  }

  async trackPublicTelemetryEvent(payload) {
    if (!payload?.aulaId) {
      throw new Error('No se encontró el aula.');
    }
    if (!payload?.tipoEvento) {
      throw new Error('No se indicó el evento de telemetría.');
    }
    return apiService.postPublic('/aulas/publico/telemetria', payload);
  }

  async trackAuthenticatedTelemetryEvent(aulaId, payload, token) {
    if (!aulaId || !token) {
      throw new Error('No se encontró la sesión del aula.');
    }
    return apiService.request(`/aulas/${encodeURIComponent(aulaId)}/telemetria`, {
      method: 'POST',
      body: payload,
      authTokenOverride: token
    });
  }

  async validatePublicCaptcha(captchaToken) {
    if (!captchaToken) throw new Error('Captcha requerido');
    return apiService.postPublic('/aulas/publico/captcha', { captchaToken });
  }

  async createAula(payload) {
    const response = await apiService.post('/aulas', payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear el aula.';
      throw new Error(msg);
    }
    return response;
  }

  async createAulaProfesor(payload) {
    const response = await apiService.post('/aulas/mis', payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos crear el aula.';
      throw new Error(msg);
    }
    return response;
  }

  async updateAula(id, payload) {
    const response = await apiService.put(`/aulas/${id}`, payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el aula.';
      throw new Error(msg);
    }
    return response;
  }

  async updateAulaProfesor(id, payload) {
    const response = await apiService.put(`/aulas/mis/${id}`, payload);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el aula.';
      throw new Error(msg);
    }
    return response;
  }

  async updateAulaActivo(id, activo) {
    const response = await apiService.put(`/aulas/${id}/activo`, { activo });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el estado del aula.';
      throw new Error(msg);
    }
    return response;
  }

  async updateAulaActivoProfesor(id, activo) {
    const response = await apiService.put(`/aulas/mis/${id}/activo`, { activo });
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos actualizar el estado del aula.';
      throw new Error(msg);
    }
    return response;
  }

  async deleteAula(id) {
    const response = await apiService.delete(`/aulas/${id}`);
    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos eliminar el aula.';
      throw new Error(msg);
    }
    return response;
  }
}

const aulaService = new AulaService();
export default aulaService;
